"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageUploadWithCropping = void 0;
var Croppie = require("croppie");
var ImageUploadWithCropping = (function () {
    function ImageUploadWithCropping(element) {
        this.element = element;
        this.OnCreate();
    }
    ImageUploadWithCropping.prototype.OnCreate = function () {
        var _this = this;
        var imagePreview = _this.element.closest('.md-form').find('#image-preview');
        var croppieElement = _this.element.closest('.md-form').find('#image-upload-croppie');
        var confirmCropButton = _this.element.closest('.md-form').find('#btn-confirm-crop');
        var clearButton = _this.element.closest('.md-form').find("#clear-image-button");
        var inputElement = _this.element.closest('.md-form').find('input[type=file]');
        var emptyImage = imagePreview.data('fallback-src');
        inputElement.click(function () {
            inputElement.val('');
        });
        var croptions = {
            viewport: {
                width: 100,
                height: 100,
                type: 'circle'
            }
        };
        var croppie = new Croppie(croppieElement[0], croptions);
        function resetCroppie() {
            croppie.destroy();
            croppie = new Croppie(croppieElement[0], croptions);
        }
        this.element.on('change', function () {
            resetCroppie();
            var reader = new FileReader();
            var htmlInputElement = _this.element.get(0);
            if (htmlInputElement.files && htmlInputElement.files[0]) {
                reader.readAsDataURL(htmlInputElement.files[0]);
            }
            reader.onload = function (e) {
                imagePreview.hide();
                clearButton.hide();
                croppieElement.show();
                confirmCropButton.show();
                var result = e.target.result;
                croppie.bind({ url: result });
            };
            confirmCropButton.on('click', function (e) {
                croppie.result({
                    type: 'base64',
                    circle: false,
                    format: 'jpeg',
                    size: 'original'
                }).then(function (result) {
                    croppieElement.hide();
                    confirmCropButton.hide();
                    imagePreview.attr('src', result);
                    imagePreview.show();
                    clearButton.show();
                    $('#hidden-image-input').val(result);
                });
            });
        });
        clearButton.on('click', function (e) {
            imagePreview.attr('src', emptyImage);
            inputElement.val('');
            $('#hidden-image-input').val('');
        });
    };
    return ImageUploadWithCropping;
}());
exports.ImageUploadWithCropping = ImageUploadWithCropping;
